import { ProductDetailsPayload } from '@/types/ProductDetail.type';

export const productDetailToListDataRow = (productDetails: ProductDetailsPayload) => ({
  sku: productDetails.sku,
  title: productDetails.description,
  make: productDetails.make,
  model: productDetails.model,
  body: productDetails.body,
  transmission: productDetails.transmission,
  ancapRating: productDetails.ancapRating,
  colour: productDetails.colour,
  buildYear: productDetails.buildYear,
  price: productDetails.price.toString(),
  state: productDetails.state,
  hotspots: productDetails.hotspots,
});
